<div class="search-bar-container">
  <div class="search-bar">
    <form [formGroup]="searchForm">
      <input
        type="search"
        [placeholder]="placeHolder || 'Search and Press Enter'"
        formControlName="searchInput"
        (keydown.enter)="onSearch($event)"
        (change)="onClear($event)"
        required
      />
    </form>
    <button class="search-btn" (click)="onSearchClick()">
      <mat-icon>search</mat-icon>
    </button>
  </div>
</div>
